<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="assignPermissionModal"
        persistent
        scrollable
        max-width="900px"
      >
        <v-card>
          <v-card-title class="pb-0">
            <v-flex
              xs11
              sm10
              md10
            ><span class="headline">
                Assign permission to [{{ formData.role ? formData.role.status : '' }}] role
              </span></v-flex>
            <v-flex
              xs1
              sm2
              md2
            >
              <v-btn
                flat
                @click="closeDialog()"
                class="close"
              >
                &nbsp;X</v-btn>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-alert
              type="success"
              :value="isDone"
            >
              {{ 'Saved successfully' }}
            </v-alert>

            <v-alert
              type="error"
              :value="errorAlert"
            >
              There is an error
            </v-alert>
            <v-layout wrap>
              <v-flex xs12>
                <v-checkbox
                  label="Check all"
                  v-model="checkAll"
                  class="my-0"
                  @change="handleCheckAll(checkAll)"
                />
              </v-flex>

              <v-flex
                xs12
                v-for="(permission, index) in formData.permissions"
                :key="index"
                class="mb-4 px-3 pt-3 pb-1 permission-group"
              >
                <div class="group-name px-3">{{ index.replaceAll('_', ' ') }}</div>
                <div
                  v-for="(p, pIndex) in permission"
                  :key="pIndex"
                  class="col-sm-6"
                >
                  <v-checkbox
                    v-model="p.checked"
                    :value="p.id"
                    hide-details
                    class="my-1"
                    :label="p.name"
                  />
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="closeDialog()"
              outline
              color="normal"
            >Cancel</v-btn>
            <v-btn
              @click="submitForm()"
              :loading="loading"
              style="height:auto; margin-right: 2%"
              outline
              color="success"
            >
              {{ 'Save' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: ['assignPermissionModal', 'formData'],

  data() {
    return {
      loading: false,
      isDone: false,
      errorAlert: false,
      checkAll: false
    }
  },

  methods: {
    handleCheckAll(checkAll) {
      if (checkAll) {
        for (let permission in this.formData.permissions) {
          this.formData.permissions[permission].forEach(p => {
            p.checked = true
          })
        }
      } else {
        for (let permission in this.formData.permissions) {
          this.formData.permissions[permission].forEach(p => {
            p.checked = false
          })
        }
      }
    },

    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true

          Axios.post(`api/role/${this.formData.role.role_id}/assign-permission`, this.formData, {
            headers: { Authorization: 'Bearer ' + token }
          })
            .then(() => {
              swal({
                title: 'Saved',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
              // this.errorAlert = false
              // this.isDone = true
              // setTimeout(() => {
              // this.isDone = false
              this.$emit('resetTable')
              this.closeDialog()
              // }, 2000)
            })
            .catch(error => {
              swal(`${error.response.data.message}`, '', 'error')
              // this.isDone = false
              // this.errorAlert = true
              // setTimeout(() => {
              //   this.errorAlert = false
              // }, 1500)
            }).finally(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}

.permission-group {
  border: 1px solid #ccc;
  border-radius: 6px;
  position: relative;
}

.group-name {
  position: absolute;
  top: -10px;
  left: 5px;
  background: #fff;
  font-size: 14px;
  text-transform: capitalize;
  color: rgba(0, 0, 0, 0.5);
}

.input-group.input-group--selection-controls label {
  left: 0px !important;
  top: -3px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/roles/assignPermission.vue